import { getHojeBR } from '../../utils/dataBR';

const IconStar = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="none">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

// Gera a lista de datas (YYYY-MM-DD) do desafio
function getDatasDoDesafio(dataInicio, duracao) {
  const datas = [];
  for (let i = 0; i < duracao; i++) {
    const d = new Date(dataInicio + 'T00:00:00');
    d.setDate(d.getDate() + i);
    datas.push(d.toISOString().split('T')[0]);
  }
  return datas;
}

export default function DesafioAtivoCard({ desafio, logs = [], embedded = false }) {
  const datas = getDatasDoDesafio(desafio.data_inicio, desafio.duracao);

  // Mapa de data → escreveu (true/false)
  const logsMap = {};
  logs.forEach(l => {
    logsMap[l.date] = !!(l.note && l.note.trim().length > 0);
  });

  // Dias com escrita real dentro do desafio
  const diasEscritos = datas.filter(d => logsMap[d]).length;

  const hoje = getHojeBR();

  return (
    <div className={`desafio-ativo-card${embedded ? '' : ' card'}`}>
      <div className="desafio-ativo-header">
        <div className="desafio-ativo-label">
          <IconStar />
          <span>Desafio ativo</span>
        </div>
        <span className="desafio-ativo-progresso">
          {diasEscritos} de {desafio.duracao} dias
        </span>
      </div>

      <h3 className="desafio-ativo-nome">{desafio.desafio_nome}</h3>

      {desafio.frase_inspiradora && (
        <p className="desafio-ativo-frase">"{desafio.frase_inspiradora}"</p>
      )}

      <div className="desafio-progress-bar">
        {datas.map((data, i) => {
          const escreveu = logsMap[data];
          const eHoje = data === hoje;
          const futura = data > hoje;
          return (
            <div
              key={data}
              className={`desafio-progress-bloco ${escreveu ? 'feito' : ''} ${eHoje ? 'hoje' : ''} ${futura ? 'futuro' : ''}`}
              title={`Dia ${i + 1}${escreveu ? ' — escreveu ✓' : eHoje ? ' — hoje' : ''}`}
            />
          );
        })}
      </div>
    </div>
  );
}
